module.exports = __webpack_public_path__ + "img/hood depth.f23c7118.png";